module.exports = __webpack_public_path__ + "static/img/RALZ-10_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RALZ-10_1.png
// module id = /jc6
// module chunks = 0